"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateTypeName = function validateTypeName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('lookup.error.typeName')));
      } else if (_this.errorKeys.indexOf('typeName') >= 0) {
        callback(new Error(_this.errorInfo['typeName']));
        _this.resetError('typeName');
      } else {
        callback();
      }
    };
    var validateTypeCode = function validateTypeCode(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('lookup.error.typeCode')));
      } else if (_this.errorKeys.indexOf('typeCode') >= 0) {
        callback(new Error(_this.errorInfo['typeCode']));
        _this.resetError('typeCode');
      } else {
        callback();
      }
    };
    var validateValueCode = function validateValueCode(rule, value, callback) {
      // valueCode[1]
      // values.1.valueCode
      var tmpArr = rule.field.split('.');
      var index = "valueCode[".concat(tmpArr[1], "]");
      if (_this.errorKeys.indexOf(index) >= 0) {
        callback(new Error(_this.errorInfo[index]));
        _this.resetError(index);
      } else {
        callback();
      }
    };
    var validateValueName = function validateValueName(rule, value, callback) {
      var tmpArr = rule.field.split('.');
      var index = "valueName[".concat(tmpArr[1], "]");
      if (_this.errorKeys.indexOf(index) >= 0) {
        callback(new Error(_this.errorInfo[index]));
        _this.resetError(index);
      } else {
        callback();
      }
    };
    return {
      pageName: 'lookup',
      formLabelWidth: '90px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      isShowModelView: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        typeName: '',
        typeCode: ''
      },
      dialogStatus: 'create',
      form: {
        lookupTypePk: '',
        typeName: '',
        typeCode: '',
        remark: '',
        values: [{
          valueCode: '',
          valueName: '',
          state: true
        }]
      },
      initForm: {
        lookupTypePk: '',
        typeName: '',
        typeCode: '',
        remark: '',
        values: [{
          valueCode: '',
          valueName: '',
          state: true
        }]
      },
      rules: {
        typeName: [{
          required: true,
          trigger: ['change'],
          validator: validateTypeName
        }],
        typeCode: [{
          required: true,
          trigger: ['change'],
          validator: validateTypeCode
        }],
        valueCode: [{
          required: true,
          trigger: ['change'],
          validator: validateValueCode
        }],
        valueName: [{
          required: true,
          trigger: ['change'],
          validator: validateValueName
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          typeName: this.searchVal.typeName,
          typeCode: this.searchVal.typeCode
        }
      };
      this.listLoading = true;
      this.$api.lookup.getLookupList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        lookupTypePk: '',
        typeName: '',
        typeCode: '',
        remark: '',
        values: [{
          valueCode: '',
          valueName: '',
          state: true
        }]
      };
      this.initForm = {
        lookupTypePk: '',
        typeName: '',
        typeCode: '',
        remark: '',
        values: [{
          valueCode: '',
          valueName: '',
          state: true
        }]
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.lookupTypePk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    view: function view(row) {
      var _this5 = this;
      this.dialogStatus = 'check';
      this.currentId = row.lookupTypePk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this5.isShowModelView = true;
      });
    },
    closeView: function closeView() {
      this.isShowModelView = false;
    },
    getDetail: function getDetail() {
      var _this6 = this;
      return new Promise(function (resolve) {
        _this6.isLoading = true;
        _this6.$api.lookup.getLookupDetail(_this6.currentId).then(function (res) {
          _this6.isLoading = false;
          var _res$data = res.data,
            lookupTypePk = _res$data.lookupTypePk,
            typeName = _res$data.typeName,
            typeCode = _res$data.typeCode,
            remark = _res$data.remark;
          var values = res.data.values;
          values = (0, _index.deepClone)(values);
          values.forEach(function (item) {
            if (item.state === 'ENABLE') {
              item.state = true;
            } else {
              item.state = false;
            }
          });
          var initValues = (0, _index.deepClone)(values);
          _this6.form = {
            lookupTypePk: lookupTypePk,
            typeName: typeName,
            typeCode: typeCode,
            remark: remark,
            'values': values
          };
          _this6.initForm = {
            lookupTypePk: lookupTypePk,
            typeName: typeName,
            typeCode: typeCode,
            remark: remark,
            'values': initValues
          };

          // console.log('111---', this.form.values[1].state, this.initForm.values[1].state)

          resolve(_this6.form);
        }).catch(function () {
          _this6.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this7.isLoading = true;
        _this7.$api.lookup.deleteLookup([row.lookupTypePk]).then(function (res) {
          _this7.isLoading = false;
          _this7.refreshData();
        }).catch(function () {
          _this7.isLoading = false;
        });
      }).catch(function () {});
    },
    addValue: function addValue() {
      this.form.values.push({
        valueCode: '',
        valueName: '',
        state: true
      });
    },
    deleteValue: function deleteValue(index) {
      this.form.values.splice(index, 1);
    },
    saveItem: function saveItem() {
      var _this8 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this8.isLoading = true;
        var formData = (0, _index.deepClone)(_this8.form);
        formData.values.forEach(function (item) {
          if (item.state) {
            item.state = 'ENABLE';
          } else {
            item.state = 'DISABLED';
          }
        });
        _this8.$api.lookup.saveLookup(formData).then(function (res) {
          _this8.isLoading = false;
          _this8.isShowModel = false;
          _this8.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this8.resetError();
            err.errorInfos.forEach(function (item) {
              _this8.errorKeys.push(item.key);
              _this8.errorInfo[item.key] = item.errMsg;
            });
            _this8.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this8.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};